var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ATTENDANCE_SAVED } from '../events';
import { summarizeReport } from './utils/summarize-report';
/**
 * Builds the `attendance_saved` event from the report the API just accepted, so
 * the payload describes what was really stored instead of the form state.
 * Tenant, role and user id are not repeated here: they are user properties set
 * by `identifyUser`.
 *
 * One event per save, not per student mark: marks are only real once saved, and
 * the per-student detail is carried by the counts above.
 */
export function buildAttendanceSavedEvent(report, context) {
    var summary = summarizeReport(report);
    var properties = __assign(__assign({ student_count: context.studentCount }, summary), { has_changes: summary.mark_count > 0, is_double_shift: context.isDoubleShift, is_backdated: context.isBackdated, term_id: context.termId, stage_id: context.stageId, division_id: context.divisionId });
    return {
        name: ATTENDANCE_SAVED,
        properties: properties
    };
}
